export default "__VITE_ASSET__uk0gk7zy__"